import { useSideEffectOnMount } from "@web-monorepo/hooks";
import { clsx } from "clsx";
import { useRef } from "react";
import styles from "./TimeInput.module.css";

type TimeInputProps = {
  value: number;
  selected: boolean;
  onFocus: VoidFunction;
  onChange: (input: number) => void;
};

export default function TimeInput({ value, selected, onFocus, onChange }: TimeInputProps) {
  // Programmatic focus on mount — avoids `autoFocus` (which an eslint rule flags
  // as an a11y smell). Both <TimeInput>s in CustomTimeModal call focus(); React's
  // left-to-right mount order means the seconds input is focused last, matching
  // the pre-migration autoFocus="true" behavior on both.
  const inputRef = useRef<HTMLInputElement>(null);
  useSideEffectOnMount(() => {
    inputRef.current?.focus();
  });

  return (
    <input
      ref={inputRef}
      type="number"
      value={value < 10 ? `0${value}` : value.toString().trim()}
      onChange={(e) => {
        if (Number(e.target.value) > 99) return;
        onChange(Number(e.target.value));
      }}
      onFocus={onFocus}
      className={clsx(styles.input, selected && styles.selected)}
    />
  );
}
